import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { CustomButtonModel } from '@fi-app/core/custom-button.model';

@Component({
    selector: 'fi-role-custom-button-edit-dialog',
    template: `
        <p class="bold">{{ customButton.GetName() }}</p>

        <div class="application-settings-container">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'access_level.local_level' | fiAppText }}</mat-label>

                <mat-select
                    panelClass="multi-color-select"
                    [(value)]="customButton.IsSelected"
                    [class]="'mat-select-value-' + getCustomButtonClass()"
                >
                    <mat-option [value]="false" [class]="customButtonNotSelectedClassName">
                        {{ 'common.disabled' | fiAppText }}
                    </mat-option>
                    <mat-option [value]="true" [class]="customButtonSelectedClassName">
                        {{ 'common.read' | fiAppText }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="group-description-container">
            <p class="group-description-title bold">{{ 'common.read' | fiAppText }}</p>
            <span class="group-description">{{ 'access_right.custom_group_read_description' | fiAppText }}</span>
        </div>
    `,
    styleUrls: [
        '../../role-application-setting/role-application-setting-edit-dialog/role-application-setting-edit-dialog.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-role-custom-button-edit-dialog' },
    standalone: false,
})
export class RoleCustomButtonEditDialogComponent
    extends FiDialogsContentBase<CustomButtonModel, boolean>
    implements OnInit
{
    customButton: CustomButtonModel;
    readonly customButtonSelectedClassName: string = 'orange';
    readonly customButtonNotSelectedClassName: string = 'grey';

    ngOnInit(): void {
        this.copyData();
    }

    getCustomButtonClass(): string {
        return this.customButton.IsSelected
            ? this.customButtonSelectedClassName
            : this.customButtonNotSelectedClassName;
    }

    private copyData() {
        this.customButton = new CustomButtonModel(this.data, this.data.orderedLangs[1], this.data.orderedLangs[0]);
        this.customButton.IsSelected = this.data.IsSelected;
    }

    getResult(): boolean {
        return this.customButton.IsSelected;
    }
}
